// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".old-release-banner[data-v-088995a6] {\n  top: 64px;\n  position: fixed;\n  background-color: #FAEFB8;\n  width: 100%;\n  margin-bottom: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
